
import {EN_KO} from './../helpers/GlobalsHelper';
import ScrollClass from '../modules/ScrollClass';
import StickyObserver from "../modules/StickyObserver";


const initStickyHeader = function() {

	// Sticky Header.
	const headerEl = document.querySelector( '.mdl_header' )
	return new StickyObserver( headerEl, ( stuck ) => {
		headerEl.classList.toggle( 'is_sticky', stuck );
	} );
};

const initStickyBackToTopButton = function() {

	// Back To Top Button.
	const backToTopBtn = document.querySelector( '.back_to_top' );
	if ( backToTopBtn ) {
		return new ScrollClass( backToTopBtn, {
			class: 'en_is_visible',
			data: {
				start: 300,
				end: undefined
			}
		} );
	}
};

const initStickyBasketAggregation = function() {

	const aggregationStickyEl = document.querySelector( '.aggregation_sticky_mobile' );
	if ( aggregationStickyEl ) {

		const aggregationControlEl = document.querySelector( '.aggregation_controls' );
		return new ScrollClass( aggregationStickyEl, {
			class: 'en_is_sticky',
			cbCalc: function( data, pageInfo, instance, force ) { // eslint-disable-line no-unused-vars

				// Get Top Offset of the Element we want to End the scrolling at.
				const endOffset = document.documentElement.scrollTop + aggregationControlEl.getBoundingClientRect().top;

				data.start = undefined;
				data.end = endOffset - window.innerHeight;
			}
		} );
	}
};

const initStickyArticleDetailAddToCart = function() {

	const stickyAddToCartEl = document.querySelector( '.en_mdl_article_detail__sticky_mobile' );
	if ( stickyAddToCartEl ) {
		const mdlFooterEl = document.querySelector( '.mdl_footer' );
		let detailButtonEl = document.querySelector( '.en_mdl_article_detail__buttons .en_mdl_article_detail__button' );

		return new ScrollClass( stickyAddToCartEl, {
			class: 'en_is_sticky',
			cbCalc: function( data, pageInfo, instance, force ) { // eslint-disable-line no-unused-vars
				// Update Element, if it is no longer connected.
				if ( ! detailButtonEl.isConnected ) {
					detailButtonEl = document.querySelector( '.en_mdl_article_detail__buttons .en_mdl_article_detail__button' );
				}

				// Get Top Offset for button and footer elements.
				const buttonOffsetTop = document.documentElement.scrollTop + detailButtonEl.getBoundingClientRect().top;
				const footerOffsetTop = document.documentElement.scrollTop + mdlFooterEl.getBoundingClientRect().top;

				// Set Start and End Offsets.
				data.start = buttonOffsetTop - detailButtonEl.offsetHeight;
				data.end = footerOffsetTop - window.innerHeight;
			}
		} );
	}
};

const initStickyFacetFilterBackToTop = function() {

	// Listpage Scroll to top button.
	const scrolltotopEl = document.querySelector( '.facet_scrolltotop' );
	if( scrolltotopEl ) {
		return new StickyObserver( scrolltotopEl, ( stuck ) => {
			scrolltotopEl.classList.toggle( 'en_is_visible', stuck );
		} );
	}
};

const initStickyElements = function() {
	EN_KO.stickyElements = EN_KO.stickyElements || {};
	EN_KO.stickyElements.header = initStickyHeader();
	EN_KO.stickyElements.backToTop = initStickyBackToTopButton();
	EN_KO.stickyElements.checkoutProcessFooter = initStickyBasketAggregation();
	EN_KO.stickyElements.articleDetailAddToCart = initStickyArticleDetailAddToCart();
	EN_KO.stickyElements.filterBackToTop = initStickyFacetFilterBackToTop();
};

export {
	initStickyElements
};
